<template lang="html">
  <div>
    <h1>Register user</h1>
    <hr />
    <v-layout>
      <v-text-field solo label="Coupon" v-model="user.code.text"></v-text-field>
      <svg style="width: 55px; height: 55px;" v-if="!couponError && user.code.text != ''" id="Layer_1" version="1.1"
        viewBox="0 0 612 792" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
          <path fill="green" class="st0"
            d="M562,396c0-141.4-114.6-256-256-256S50,254.6,50,396s114.6,256,256,256S562,537.4,562,396L562,396z    M501.7,296.3l-241,241l0,0l-17.2,17.2L110.3,421.3l58.8-58.8l74.5,74.5l199.4-199.4L501.7,296.3L501.7,296.3z" />
        </g>
      </svg>
      <svg style="width: 50px; height: 50px;" v-else-if="couponError && (user.code.text != '' || user.code.text != null)"
        version="1.1" viewBox="0 0 36 36" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Layer_1" />
        <g id="icons">
          <path fill="red" class="st0"
            d="M6.2,3.5L3.5,6.2c-0.7,0.7-0.7,1.9,0,2.7l9.2,9.2l-9.2,9.2c-0.7,0.7-0.7,1.9,0,2.7l2.6,2.6   c0.7,0.7,1.9,0.7,2.7,0l9.2-9.2l9.2,9.2c0.7,0.7,1.9,0.7,2.7,0l2.6-2.6c0.7-0.7,0.7-1.9,0-2.7L23.3,18l9.2-9.2   c0.7-0.7,0.7-1.9,0-2.7l-2.6-2.6c-0.7-0.7-1.9-0.7-2.7,0L18,12.7L8.8,3.5C8.1,2.8,6.9,2.8,6.2,3.5z"
            id="close_1_" />
        </g>
      </svg>
    </v-layout>
    <v-layout v-if="isPatient">
      <div class="methods" style="margin-bottom: 10px;">
                          <div style="position: relative; margin-bottom: 12px;" v-for="(item, index) in specialties" :key="index">
                              <button :class="item.show ? 'opened' : 'open'" @click="toggleDiv(index)">

                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <mask id="mask0_10_97" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                          width="24" height="24">
                                          <rect width="24" height="24" fill="#000875" />
                                      </mask>
                                      <g mask="url(#mask0_10_97)">
                                          <path
                                              d="M8 18L12 14.95L16 18L14.5 13.05L18.5 10.2H13.6L12 5L10.4 10.2H5.5L9.5 13.05L8 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                                              fill="#000875" />
                                      </g>
                                  </svg>

                                  <span class="text">
                                      {{ item.name }}
                                  </span>

                                  <svg class="svg-open" v-if="!item.show" width="13" height="8" viewBox="0 0 13 8" fill="none"
                                      xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M12.3483 1.49436L6.2809 7.56177L0.213501 1.49436L1.29046 0.417399L6.2809 5.40784L11.2713 0.417399L12.3483 1.49436Z"
                                          fill="#1C1B1F" />
                                  </svg>
                                  <svg class="svg-open" v-else-if="item.show" width="13" height="8" viewBox="0 0 13 8"
                                      fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path
                                          d="M0.213459 6.0674L6.28086 -2.65215e-07L12.3483 6.0674L11.2713 7.14437L6.28086 2.15393L1.29042 7.14437L0.213459 6.0674Z"
                                          fill="#1C1B1F" />
                                  </svg>
                              </button>
                              <div v-if="item.show" class="hiddenDiv">
                                  <div class="opened-subgoals">
                                      <div style="display: flex;flex-wrap: wrap;justify-content: center;">
                                          <div class='subgoal-elem' style="cursor: pointer;" @click="selectItem(doc.id_user)"
                                          :class="user.selectedDoctorId != null ? (user.selectedDoctorId == doc.id_user ? 'subgoal-elem-selected' : 'subgoal-elem') : 'subgoal-elem'"
                                              v-for="(doc, indexSub) in doctorsGetItems(item.name)" :key="index + '_' + indexSub">
                                              {{ ((doc.name != null && doc.name != 'null') ? doc.name : '') + " " + ((doc.surname != null && doc.surname != 'null') ? doc.surname : '') }}
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
    </v-layout>
    <v-layout  v-if="!isPatient && user.code.text !=''">
        <v-select label="Speciality"  v-model="user.speciality" chips :items="filteredSpecialties"
          item-text="value" item-value="value" solo ></v-select>
      </v-layout>
    <v-layout>
      <v-text-field solo label="Name" v-model="user.name"></v-text-field>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Surname" v-model="user.surname"></v-text-field>
    </v-layout>
    <v-layout v-if="isPatient">
      <v-text-field solo label="Child Name" v-model="user.childName"></v-text-field>
    </v-layout>
    <v-layout v-if="isPatient">
      <v-text-field solo label="Child Age" v-model="user.childAge" min="1" max="30" type="number"></v-text-field>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Email" v-model="user.email"></v-text-field>
    </v-layout>
    <v-layout v-if="emailError">
      <label style="margin-top: -22px;margin-bottom: 7px;">{{ emailMsg }}</label>
    </v-layout>
    <v-layout>
      <vue-tel-input style="max-height: 48px; margin-bottom: 30px;" tabindex="0" class="vue-tel-input" id="phone-input" v-model="user.phone" v-bind="bindProps" @validate="validPhone" @input="clearValidation" @open="onDropdownOpen(true)"
@close="onDropdownOpen(false)"> 
        <template v-slot:arrow-icon>
  <span>{{ open ? '' : '' }}</span>
</template></vue-tel-input>
          <div class="phone-alert" v-if="phoneError && user.phone != ''">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w 3.org/1999/xlink" width="14px" height="14px"
          viewBox="0 0 14 14" version="1.1">
          <g id="surface1">
            <path style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(84.313725%, 15.686275%, 15.686275%);
                  fill-opacity: 1;
                "
              d="M 14 7 C 14 10.867188 10.867188 14 7 14 C 3.132812 14 0 10.867188 0 7 C 0 3.132812 3.132812 0 7 0 C 10.867188 0 14 3.132812 14 7 Z M 14 7 " />
            <path style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(90.196078%, 90.196078%, 90.196078%);
                  fill-opacity: 1;
                "
              d="M 6.34375 10.9375 L 7.65625 10.9375 L 7.65625 9.625 L 6.34375 9.625 Z M 6.34375 2.625 L 6.34375 8.3125 L 7.65625 8.3125 L 7.65625 2.625 Z M 6.34375 2.625 " />
          </g>
        </svg>
        <span>{{
          phoneErrorMsg
        }}</span>
      </div>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Password" v-model="user.password" @change="changePassword"></v-text-field>
    </v-layout>
    <v-layout row align-start class="pt-4" style="margin-bottom: 20px;margin-left: 0px;">
      <v-btn :disabled="emailVerified && phoneVerified ?false:true" color="success" @click="register">Register</v-btn>
    </v-layout>
  </div>
</template>
  
<script>
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';
import icons from "./icons.store";
export default {
  name: "playlist",
  data() {
    return {
      couponError: false,
      userTemplate: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        password: "",
        speciality: "ריפוי בעיסוק",
        passwordConfirm: "",
        id_organization: "",
        selectedDoctorId: "",
        childAge: 1,
        childName: "",
        facebook_id: "",
        google_id: "",
        apple_id: "",
        users: {
          secondUser: false,
          thirdUser: false,
        },
        code: {
          text: "",
          status: false,
          checked: false,
        },
        question: {
          options: ["אף פעם ", "יש כזו גלידה? ", " מה זה קשור להרשמה??"],
          selected: "",
        },
        promocode: {
          selected: {
            letter: "",
            number: "",
          },
          title: {
            position: "",
            city: "",
            school: "",
          },
        },
      },
      user: {},
      open:false,
      doctors:null,
      isPatient:false,
      timer: null,
      emailError: false,
      specialties: null,
      filteredSpecialties: null,
      emailMsg: "",
      timerEmail: null,
      emailVerified: false,
      phoneError: null,
      phoneVerified: false,
      loadinSocial: false,
      phoneErrorMsg: "",
      bindProps: {
        autoFormat: true,
        autoDefaultCountry: false,
        defaultCountry: "IL",
        validCharactersOnly: true,
        mode: "international",
        disabled: false,
        preferredCountries: ["IL", "US", "UA"],
        dropdownOptions: {
          showDialCodeInList: true,
          showFlags: true,
          width: "250px",
        },
        inputOptions: {
          showDialCode: true,
          autocomplete: "off",
          placeholder: "הזן מספר טלפון",
          required: true,
          type: "tel",
          name: "phone",
          maxLen: 25,
        },
      },
    }
  },
  watch: {
    "user.code.text": {
      handler(val, oldVal) {
        this.isPatient = false;
        this.checkCoupon();
      },
    },
    "user.email": {
      handler(val, oldVal) {
        this.validateEmail();
      },
    }
  },
  methods: {
    resetUser() {
      // Resets the user data to the default template
      this.user = JSON.parse(JSON.stringify(this.userTemplate));
    },
    selectItem(id)
    {
      if(this.user.selectedDoctorId!=id)
      {
        this.user.selectedDoctorId = id;
      }
      else
      {
        this.user.selectedDoctorId = "";
      }
    },
    doctorsGetItems(name) {
        let result = this.doctors.filter(item => item.speciality === name);
        
        return result;
    },
    getSpecialties() {
      axios.get('/specialties/get').then((res)=>{
        this.specialties = res.data.map(item => {
            this.$set(item, 'show', false);
            return item;
        });
        this.filteredSpecialties = this.specialties.map(item=>item.name);
        this.user.speciality = this.filteredSpecialties[0]!=null? this.filteredSpecialties[0] : null;
      });
    },
    toggleDiv(index) {
            this.specialties[index].show = !this.specialties[index].show;
        },
    onDropdownOpen(val)
    {
      this.open = val;
    },
    validPhone(event) {
      this.phoneError = false;
      this.phoneErrorMsg = "";
      this.phoneVerified = false;
      clearTimeout(this.timerPhone);
      this.timerPhone = setTimeout(() => {
        if (!event.valid && this.user.phone != "+972") {
          this.phoneVerified = false;
          this.phoneError = true;
          this.phoneErrorMsg = "מספר הטלפון שגוי";
        } else if (event.valid) {
          this.phoneVerified = true;
          this.phoneError = false;
        }
      }, 100);
    },
    clearValidation(){

    },
    changePassword(e) {
      this.user.passwordConfirm = e;
    },
    encryptObject(data) {
      const key = CryptoJS.enc.Utf8.parse(process.env['MIX_APP_SECURE_KEY']);
      const iv = CryptoJS.lib.WordArray.random(16);
      const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

      const objectToEncryptString = JSON.stringify(data);

      const encrypted = CryptoJS.AES.encrypt(objectToEncryptString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        keySize: 256 / 8,
      });

      const encryptedObject = {
        iv: ivBase64,
        value: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      };
      return encryptedObject;
    },
    async register() {
      let rand = (0 - 0.5 + Math.random() * (30 - 0 + 1)).toFixed();
      let newImage64 = icons[rand];

      if(this.isPatient){
        this.user.speciality = '';
      }
      let data = {
        referal_id: null,
        playlists_before_reg: 0,
        shootlists_before_reg: 0,
        indicators: null,
        speciality:this.user.speciality,
        id_organization:this.user.id_organization,
        childAge:this.user.childAge,
        childName:this.user.childName,
        selectedDoctorId:this.user.selectedDoctorId,
        name: this.user.name,
        surname: this.user.surname,
        phone: this.user.phone,
        phoneVerified: false,
        coupon: this.user.code.text,
        password: this.user.password,
        email: this.user.email,
        class: this.user.promocode.selected.letter,
        class_number: this.user.promocode.selected.number,
        image64: newImage64,
        track_data: null,
        users: this.user.users,
        usersData: this.user.usersData,
        google_id: null,
        facebook_id: null,
        apple_id: null
      };
      if(this.isPatient && (this.user.selectedDoctorId == '' || this.user.selectedDoctorId == null))
      {
        this.$notify({
          title: "Error",
          text: "Select doctor for patient",
          type: "error",
          duration: 5000,
        });
        return;
      }
      if(!this.isPatient && (this.user.speciality == '' || this.user.speciality == null))
      {
        this.$notify({
          title: "Error",
          text: "Select speciality for doctor",
          type: "error",
          duration: 5000,
        });
        return;
      }
      
      await axios.post('/admin/reg', data).then(() => {
        this.resetUser();
        this.$notify({
          title: "Success",
          text: "User successfully added",
          type: "success",
          duration: 5000,
        });
      }).catch(err => {
        this.$notify({
          title: "Error",
          text: "Error while register",
          type: "error",
          duration: 5000,
        });
      })
    },
    validateEmail() {
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,30})+$/;
      const { email } = this.user;
      this.emailError = false;
      this.emailMsg = 'האימייל שגוי';
      
      if (regex.test(email)) {
        clearTimeout(this.timerEmail);
        this.timerEmail = setTimeout(() => {
          axios.post('/admin/checkEmailAdmin', { email: email })
            .then((res) => {
              let data = res.data;
              if (data.error) {
                this.emailMsg = 'משתמש עם דוא"ל זה כבר קיים';
                this.emailError = true;
                this.$notify({
                  title: 'שְׁגִיאָה',
                  text: 'משתמש עם דוא"ל זה כבר קיים',
                  type: 'error',
                  duration: 5000,
                });
              } else {
                this.emailError = false;
                this.emailVerified = true;
                this.emailMsg = "";
              }
            })
            .catch(() => {
              this.emailError = true;
              this.emailVerified = false;
            });
        }, 1000);
      } else {
        this.emailError = true;
        this.emailVerified = false;
      }
    },
    checkCoupon(e) {
      clearTimeout(this.timer);
      if (this.user.code.text == "") {
        this.couponError = false;
      }
      else {
        this.timer = setTimeout(() => {
          if (this.user.code.text.trim() !== "") {
            axios.post('/promo/validate', { coupon: this.user.code.text })
              .then((res) => {
                if (res.data.limit === res.data.used) {
                  this.$notify({
                    title: "Error",
                    text: "Error because of limits of the coupon",
                    type: "error",
                    duration: 5000,
                  });
                  this.couponError = true;
                } else {
                  this.couponError = false;
                  if(res.data.position == 'patient')
                  {
                    this.isPatient = true;
                    this.doctors = res.data.doctors;
                    
                  }
                  else
                  {
                    this.isPatient = false;
                  }
                  this.user.id_organization = res.data.id_organization;
                }
              })
              .catch((err) => {
                this.$notify({
                  title: "Error",
                  text: "Error while checking the coupon",
                  type: "error",
                  duration: 5000,
                });
                this.couponError = true;
              });
          }
        }, 1000);
      }
    },
  },
  activated() {

  },
  async created() {
    this.getSpecialties();
  },
  mounted() {
    // Set initial user data based on the template
    this.resetUser();
  },
};
</script>
  
<style lang="scss" scoped>
.methods {
        width: 100%;
        margin-top: 10px;
        .selectedSubGoals{
            width: 100%;
            margin-bottom: 17px;
            display: flex;
            flex-wrap: wrap;
            justify-content: right;

            .elementsGoals{
                height: 26px;
                background: #ADADAD;
                border-radius: 20px;
                padding: 0px 10px;
                font-family: 'App';
                font-size: 13px;
                font-weight: 400;
                line-height: 18px;
                letter-spacing: 0em;
                text-align: right;
                color:#fff;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-left: 4px;
                margin-top: 3px;
                cursor: pointer;

                svg{
                    margin-right: 7px;
                }
            }
        }

        .open {
            padding: 9px 25px;
            width: 100%;
            height: 41px;
            border-radius: 10px;
            border: 1px solid #ADADAD;
            text-align: right;
            background: rgba($color: #fff, $alpha: 0.7);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;

            svg {
                margin-left: 4px;
            }

            .svg-open {
                position: absolute;
                left: 6px;
            }
        }

        .opened {
            padding: 9px 25px;
            width: 100%;
            height: 41px;
            border: 1px solid #ADADAD;
            background: rgba($color: #fff, $alpha: 0.7);
            border-radius: 10px 10px 0 0;
            /* Задаем радиусы углов: верхние углы - закруглены, нижние - прямоугольные */
            border-bottom: none;
            /* Убираем нижнюю границу */
            text-align: right;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;

            svg {
                margin-left: 4px;
            }

            .svg-open {
                position: absolute;
                left: 6px;
            }
        }

        .opened-subgoals {
            width: 100%;
            height: 100%;
            border: 1px solid #ADADAD;
            background: rgba($color: #fff, $alpha: 0.7);
            border-radius: 0 0 10px 10px;
            border-top: none;
            padding: 13px 0px 24px 0px;

            .text{
                width: 100%;
                display: 100%;
                text-align: right;
                margin-right: 9px;
                margin-bottom: 17px;
                .styles{
                    font-family: 'App';
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 18px;
                    letter-spacing: 0em;
                    text-align: right;
                    color: #000;
                }
            }

            .subgoal-elem {
              width: 92px;
              height: 72px;
              border-radius: 10px;
              background: #F1F3F5;
              border: 1px solid #ADADAD;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              -webkit-box-pack: center;
              -ms-flex-pack: center;
              justify-content: center;
              color: #000;
              margin: 0px 4.5px 13px 4.5px;
              font-family: "App";
              font-size: 15px;
              font-weight: 400;
              line-height: 20px;
              padding: 5px;
              letter-spacing: 0em;
              text-align: center;
            }

            .subgoal-elem-selected {
                width: 92px;
                height: 72px;
                border-radius: 10px;
                background: #ADADAD;
                display: flex;
                padding: 5px;
                align-items: center;
                justify-content: center;
                color: #fff;
                margin: 0px 4.5px 13px 4.5px;
                font-family: 'App';
                font-size: 15px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 0em;
                text-align: center;
            }
        }

        .text {
            font-family: 'App';
            font-size: 15px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: right;
            color: #000;
        }
    }
.style-one {
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: -10px 5px !important;
  border-radius: 4px;
}

.vue-tel-input ::v-deep .vti__dropdown {
  border: 1px solid white;
  background: white;
  border-radius: 4px;
  padding: 20px 10px 20px 13px;
  margin-right: 10px;
}

.vue-tel-input ::v-deep .vti__input {
  border: 1px solid white;
  background: white;
  border-radius: 4px;
  padding: 20px 20px 20px 27px;
  margin-right: 10px;
  width: 224px !important;
}

.vue-tel-input ::v-deep .vti__flag {
  scale: 1.2;
}

.vue-tel-input ::v-deep .vti__dropdown-arrow {
  margin-left: 10px;
}

.vue-tel-input {
  box-shadow: none;
}

.vue-tel-input {
  box-shadow: none;
}

.phone-alert {
  width: 300px;
    margin: auto;
    margin-top: 15px;
    margin-left: 0px;
    text-align: justify;
    display: flex;
    align-items: center;
  position: relative;
  font-family: "App";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  text-align: right;

  color: #000;

  svg {
    // position: absolute;
    // top: 61px;
    // right: 3px;
    margin: 0px 5px;
  }
}
</style>
  